import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { numberAsCurrency } from '../../utils/index';
import PictureBanner from '../../components/PictureBanner';

const useStyles = makeStyles((theme) => ({
  root: {
    border: '1px solid #E2E7F0',
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    padding: '14px',
    marginBottom: '14px',
    textAlign: 'left',
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '88px minmax(0, 1fr) auto',
    gap: '12px',
    alignItems: 'stretch',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '72px minmax(0, 1fr) auto',
      gap: '10px',
    },
  },
  thumb: {
    width: '88px',
    height: '88px',
    borderRadius: '10px',
    overflow: 'hidden',
    backgroundColor: '#F0F2F5',
    flexShrink: 0,
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
    [theme.breakpoints.down('xs')]: {
      width: '72px',
      height: '72px',
    },
  },
  info: {
    minWidth: 0,
  },
  title: {
    fontWeight: 700,
    color: '#2D6E2F',
    fontSize: '0.9rem',
    lineHeight: 1.3,
    marginBottom: '6px',
    wordBreak: 'break-word',
  },
  priceLine: {
    fontSize: '0.8125rem',
    color: '#3B7E3D',
    marginBottom: '4px',
    '& span': {
      fontWeight: 700,
    },
  },
  productCode: {
    fontSize: '0.72rem',
    color: '#666666',
    fontWeight: 500,
  },
  ticketsBadge: {
    backgroundColor: '#D4EDDA',
    color: '#1A1A1A',
    borderRadius: '20px',
    padding: '6px 12px',
    fontSize: '0.78rem',
    fontWeight: 700,
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
  ticketsBadgeCompleted: {
    backgroundColor: '#F8D7DA',
    color: '#721C24',
  },
  badgeCol: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
}));

export default function OrderProductCard({ order }) {
  const classes = useStyles();
  if (!order?.campaign) return null;

  const { campaign } = order;
  const code = campaign.code || campaign.id;
  const isCompletedCampaign = campaign['open?'] === false;

  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <div className={classes.thumb}>
          <PictureBanner
            avifUrl={campaign.square_banner_url}
            webpUrl={campaign.square_banner_webp_url}
            fallbackUrl={campaign.square_banner_url}
          />
        </div>
        <div className={classes.info}>
          <Typography component="h2" className={classes.title}>
            {campaign.title}
          </Typography>
          <Typography component="p" className={classes.priceLine}>
            POR APENAS <span>{numberAsCurrency(campaign.ticket_price)}</span>
          </Typography>
          <Typography component="p" className={classes.productCode}>
            Produto: {code}
          </Typography>
        </div>
        <div className={classes.badgeCol}>
          <span className={`${classes.ticketsBadge} ${isCompletedCampaign ? classes.ticketsBadgeCompleted : ''}`}>
            {order.numbers_count} títulos
          </span>
        </div>
      </div>
    </div>
  );
}
